import Vue from 'vue'
import Router from 'vue-router'
import {BlankLayout} from '@/layouts'
import blankLayout from "@/layouts/BlankLayout";

// hack router push callback
// [解决 vue-router跳转相同路径报错 ]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 纯静态路由配置项
const constantRouterMap = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/user/login'),
        meta: { title: '登录' }
    },
    {
        path: '/login',
        redirect: '/'
    },
    {
        path: '/index',
        component: () => import('@/views/home/index'),
        meta: { title: '管理首页' }
    },
    {
        path: '/noticelist',
        component: () => import('@/views/home/noticelist'),
        meta: { title: '公告列表' }
    },
    {
        path: '/knowledgelist',
        component: () => import('@/views/home/knowledgelist'),
        meta: { title: '知识库' }
    },
    {
        path: '/register',
        component: () => import('@/views/register/register'),
        meta: { title: '注册' }
    },
    {
        path: '/card-index',
        component: () => import('@/views/card/index'),
        meta: { title: '网卡列表' }
    },
    {
        path: '/terminal-index',
        component: () => import('@/views/terminal/index'),
        meta: { title: '终端列表' }
    },
    {
        path: '/beoverdue-index',
        component: () => import('@/views/beoverdue/index'),
        meta: { title: '逾期列表' }
    },

    {
        path: '/orderlist',
        component: () => import('@/views/user/orderlist'),
        meta: { title: '订单列表' }
    },
    {
        path: '/userinfo',
        component: () => import('@/views/user/userinfo'),
        meta: { title: '用户信息' }
    },
    {
        path:'/modify',
        component: () => import('@/views/modify/modify'),
        meta: { title: '忘记密码' }
    }
]

export default new Router({
    // mode: 'history',
    routes: constantRouterMap
})
